import I18n from 'I18n';
import { isEmpty, isEqual, sortBy, uniqueId } from 'underscore';
import { LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import FormKeys from 'forms-utils-lib/constants/formDefinition/FormKeys';
import Themes from 'FormsUI/lib/Themes';
const getLegalConsent = (value, {
  legalConsentOptions
}) => {
  try {
    return new LegalConsent(legalConsentOptions || JSON.parse(value));
  } catch (error) {
    return {};
  }
};
export const getDefaults = definition => {
  const maybeSetDefaults = {};
  if (isEmpty(definition[FormKeys.THANK_YOU_MESSAGE]) && isEmpty(definition[FormKeys.REDIRECT_PAGE])) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    maybeSetDefaults[FormKeys.THANK_YOU_MESSAGE] = I18n.text('defaultForm.thankYouMessage');
  }
  if (isEmpty(definition[FormKeys.THEME_NAME])) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    maybeSetDefaults[FormKeys.THEME_NAME] = Themes.getDefaultTheme();
  }
  return {
    maybeSetDefaults
  };
};
export const getFormFieldGroups = definition => {
  const formFieldGroupsWithRichTextId = sortBy(definition.formFieldGroups, formFieldGroup => -formFieldGroup.default) // put queued fields at the bottom
  .map(formFieldGroup => {
    return Object.assign({}, formFieldGroup, {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      richText: Object.assign({}, formFieldGroup.richText, {
        privateInternalId: Number(uniqueId())
      })
    });
  });
  return {
    formFieldGroups: formFieldGroupsWithRichTextId
  };
};
export const getMetaData = (definition, options) => {
  const parsedMetaData = definition.metaData.map(({
    name,
    value
  }) => Object.assign({
    name
  }, isEqual(name, LEGAL_CONSENT_OPTIONS_KEY) ? {
    value: getLegalConsent(value, options)
  } : {
    value
  }));
  return {
    metaData: parsedMetaData
  };
};
export function hydrateFormWithDefaults(definition, options = {}) {
  return Object.assign({}, definition, getDefaults(definition), getFormFieldGroups(definition), getMetaData(definition, options));
}
export default hydrateFormWithDefaults;